<section class="header" [ngClass]="{ 'header--padding': addPadding() }">
  <h2 class="header__title">{{ title() }}</h2>
  <p-buttonGroup
    class="header__buttons"
    [ngClass]="{
      'header__buttons--center': buttonAlignment() === 'center',
      'header__buttons--left': buttonAlignment() === 'left',
      'header__buttons--right': buttonAlignment() === 'right',
    }"
  >
    @for (buttonOption of buttonOptions(); track $index) {
      <p-button
        [label]="buttonOption.label"
        [disabled]="buttonOption.disabled"
        [icon]="buttonOption.icon"
        [iconPos]="buttonOption.position"
        [severity]="buttonOption.severity ?? 'primary'"
        (click)="buttonOption.click?.()"
        [badge]="buttonOption.badge"
        [variant]="buttonOption.variant ?? null"
      ></p-button>
    }
  </p-buttonGroup>
</section>
